import { render, staticRenderFns } from "./ChartDetail.vue?vue&type=template&id=f05f13ea"
import script from "./ChartDetail.vue?vue&type=script&lang=js"
export * from "./ChartDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports